import React from 'react';
import List from '@material-ui/core/List';
import { Grid } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import Avatar from '@material-ui/core/Avatar';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import { useTranslation } from 'react-i18next';
import { textToSnakeCase } from '../../utils/utils';

export default function ProfileOptionsHeader({ userInfo, classes }) {
  const { t } = useTranslation();

  return (
    <List
      component="nav"
      className={classes.profileOptionsHeader}
      aria-label="mailbox folders"
    >
      <Grid
        container
        spacing={1}
        direction="row"
        justify="flex-start"
        alignItems="flex-start"
        alignContent="stretch"
        wrap="nowrap"
      >
        <Grid item xs={2}>
          {' '}
          <ListItem>
            <ListItemAvatar style={{ marginTop: 7 }}>
              <Avatar
                className={classes.profileHeaderAvatar}
                variant="circular"
              />
            </ListItemAvatar>
          </ListItem>
        </Grid>
        &nbsp; &nbsp;
        {userInfo.data ? (
          <Grid item xs={10} className={classes.textStyle}>
            {' '}
            <Grid item>
              {t('app.userInfo.reportingUnit')}:{' '}
              <strong>
                {userInfo.data.payload.reportingUnitIds[0].relatedNumber}
              </strong>{' '}
            </Grid>
            <Grid item>
              {t('app.userInfo.userName')}:{' '}
              <strong>
                {userInfo.data.payload.profile.lastName},{' '}
                {userInfo.data.payload.profile.firstName}
              </strong>
            </Grid>
            <Grid item>
              {t('app.userInfo.userId')}:{' '}
              <strong>{userInfo.data.payload.loginName}</strong>
            </Grid>
            <Grid item>
              {t('app.userInfo.userRole')}:{' '}
              <strong>
                {t(
                  `app.userInfo.roles.${textToSnakeCase(userInfo.role.name)}`,
                  userInfo.role.name,
                )}
              </strong>
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={10} className={classes.textStyle}>
            {' '}
            <Grid item>
              {t('app.userInfo.reportingUnit')}: <strong>Admin</strong>{' '}
            </Grid>
            <Grid item>
              {t('app.userInfo.userName')}:{' '}
              {userInfo.family_name && userInfo.given_name ? (
                <strong>
                  {userInfo.family_name}, {userInfo.given_name}
                </strong>
              ) : (
                <strong>{userInfo.name}</strong>
              )}
            </Grid>
            <Grid item>
              {t('app.userInfo.userId')}: <strong>{t('app.common.na')}</strong>
            </Grid>
            <Grid item>
              {t('app.userInfo.userRole')}:{' '}
              <strong>{t('app.userInfo.admin')}</strong>
            </Grid>
          </Grid>
        )}
      </Grid>
    </List>
  );
}
